const Title = () => {
  return (
    <header className="mb-8 flex w-full flex-col gap-3">
      <h1 className="typo-heading-2">1:1 문의</h1>
    </header>
  );
};

export default Title;
